export const calculateAgeFromNRIC = (nric) => {
  if (!nric || nric.length < 6) {
    return null; // NRIC too short to extract date
  }

  const yearPart = parseInt(nric.substring(0, 2), 10);
  const monthPart = parseInt(nric.substring(2, 4), 10);
  const dayPart = parseInt(nric.substring(4, 6), 10);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // getMonth() is 0-indexed
  const currentDay = new Date().getDate();

  let birthYear;

  if (yearPart >= (currentYear % 100) + 5) { // Adjusted pivot for better accuracy
    birthYear = 1900 + yearPart;
  } else {
    birthYear = 2000 + yearPart;
  }

  const birthDate = new Date(birthYear, monthPart - 1, dayPart); // month is 0-indexed for Date constructor

  // Check for invalid date (e.g., February 30th)
  if (
    birthDate.getFullYear() !== birthYear ||
    birthDate.getMonth() !== monthPart - 1 ||
    birthDate.getDate() !== dayPart
  ) {
    return null; // Invalid date extracted from NRIC
  }

  let age = currentYear - birthYear;

  // Adjust age if birthday hasn't occurred yet this year
  if (
    currentMonth < monthPart ||
    (currentMonth === monthPart && currentDay < dayPart)
  ) {
    age--;
  }

  return age;
};

const ageGroup = {
  "<20": {
    min: 0,
    max: 20,
  },
  "21-30": {
    min: 21,
    max: 30,
  },
  "31-40": {
    min: 31,
    max: 40,
  },
  "41-50": {
    min: 41,
    max: 50,
  },
  "51-60": {
    min: 51,
    max: 60,
  },
  "61-70": {
    min: 61,
    max: 70,
  },
  ">71": {
    min: 71,
    max: 200,
  },
};

export function getAgeGroup(age) {
  let group = "";
  for (let key in ageGroup) {
    if (age >= ageGroup[key].min && age <= ageGroup[key].max) {
      group = key;
    }
  }

  return group;
}


